import * as React from "react";

export class OKButton extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <button className={'button button-secondary ' + this.props.className} onClick={this.props.onClick} >OK</button>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Controls/OkButton.js